const NAME = "PERFORMANCE_SUMMARY_AND_RESULTS";

export default NAME;
